// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.13215"][{"5433":0}[chunkId]] || "1.13216") + "/" + chunkId + ".js";
};